export const DN_PAGE_TYPE = 'beauty_portfolio';
export const DN_PAGE_SECTION = '*';
export const DN_PAGE_DATA = 'default';
